import { formatStockTakeUomOptionLabel } from './stockTakeLineTitle'

export const normalizeStockText = value =>
  String(value || '')
    .trim()
    .toLowerCase()

export const getVenueProductSku = venueProduct =>
  venueProduct?.sku || venueProduct?.product?.sku || ''

export const getVenueProductTitle = venueProduct =>
  venueProduct?.title || venueProduct?.product?.title || ''

export const getConversionRecordId = conversion =>
  String(
    conversion?.conversionId || conversion?._id || conversion?.id || '',
  ).trim()

export const findVenueProductForStockTakeProduct = (
  stockProduct,
  venueProducts = [],
) => {
  const list = Array.isArray(venueProducts) ? venueProducts : []
  const venueProductId = String(stockProduct?.venueProductId || '').trim()
  if (venueProductId) {
    const matchedById = list.find(
      venueProduct => String(venueProduct?._id || '') === venueProductId,
    )
    if (matchedById) return matchedById
  }

  const stockSku = normalizeStockText(stockProduct?.sku)
  const stockTitle = normalizeStockText(stockProduct?.title)
  const stockSupplier = normalizeStockText(stockProduct?.supplierTitle)
  const parOf = product => {
    const parsed = Number(product?.parLevel)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
  }
  const preferPar = matches =>
    matches.length
      ? [...matches].sort((left, right) => parOf(right) - parOf(left))[0]
      : null

  if (stockSku) {
    const skuMatches = list.filter(
      venueProduct =>
        normalizeStockText(getVenueProductSku(venueProduct)) === stockSku,
    )
    const preferred = preferPar(skuMatches)
    if (preferred) return preferred
  }

  if (stockTitle) {
    const titleMatches = list.filter(
      venueProduct =>
        normalizeStockText(getVenueProductTitle(venueProduct)) === stockTitle &&
        normalizeStockText(
          venueProduct?.supplierTitle || venueProduct?.supplier?.title,
        ) === stockSupplier,
    )
    const preferred = preferPar(titleMatches)
    if (preferred) return preferred
  }

  return null
}

export const getConversionRecordsForStockProduct = (
  stockProduct,
  venueProducts = [],
) => {
  const directConversions = Array.isArray(stockProduct?.conversions)
    ? stockProduct.conversions
    : []
  if (directConversions.length > 0) return directConversions

  const matchedVenueProduct = findVenueProductForStockTakeProduct(
    stockProduct,
    venueProducts,
  )
  return Array.isArray(matchedVenueProduct?.conversions)
    ? matchedVenueProduct.conversions
    : []
}

export const mapConversionRecordsToOptions = conversions =>
  (Array.isArray(conversions) ? conversions : [])
    .map(conversion => {
      const conversionId = getConversionRecordId(conversion)
      const conversionName =
        conversion?.label ||
        conversion?.title ||
        conversion?.name ||
        conversion?.displayName ||
        'Conversion'
      const conversionUnit =
        conversion?.toUnit ||
        conversion?.toUoM ||
        conversion?.UoM ||
        conversion?.unit ||
        ''
      const conversionFactor = Number(
        conversion?.toQty ??
          conversion?.factor ??
          conversion?.multiplier ??
          conversion?.value ??
          conversion?.ratio ??
          1,
      )

      if (
        !conversionId ||
        !Number.isFinite(conversionFactor) ||
        conversionFactor <= 0
      ) {
        return null
      }

      return {
        value: conversionId,
        label: formatStockTakeUomOptionLabel({
          conversionName,
          conversionUnit,
        }),
        conversionName,
        conversionUnit,
        conversionFactor,
        raw: conversion,
      }
    })
    .filter(Boolean)

export const getConversionOptionsForStockProduct = (
  stockProduct,
  venueProducts = [],
) =>
  mapConversionRecordsToOptions(
    getConversionRecordsForStockProduct(stockProduct, venueProducts),
  )
